import React from "react";
import PropTypes from "prop-types";
import { cn } from "../../lib/cn";

const toneClasses = {
  default:
    "bg-[var(--color-bg-secondary)] border-[var(--color-border-light)] text-[var(--color-text-primary)]",
  primary:
    "bg-blue-50 border-blue-200 text-blue-800 dark:bg-blue-950/30 dark:border-blue-900 dark:text-blue-200",
  success:
    "bg-emerald-50 border-emerald-200 text-emerald-800 dark:bg-emerald-950/30 dark:border-emerald-900 dark:text-emerald-200",
  warning:
    "bg-amber-50 border-amber-200 text-amber-800 dark:bg-amber-950/30 dark:border-amber-900 dark:text-amber-200",
  danger:
    "bg-rose-50 border-rose-200 text-rose-800 dark:bg-rose-950/30 dark:border-rose-900 dark:text-rose-200",
  neutral:
    "bg-[var(--color-bg-tertiary)] border-[var(--color-border-light)] text-[var(--color-text-secondary)]",
};

const WorkflowContextBar = ({ items = [], className = "" }) => {
  if (!items?.length) {
    return null;
  }

  return (
    <div className={cn("grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-2", className)}>
      {items.map((item) => (
        <div
          key={item.id}
          className={cn(
            "flex w-full items-center justify-between gap-3 rounded-2xl border px-3 py-2 min-h-[40px]",
            toneClasses[item.tone] || toneClasses.default,
          )}
        >
          <span className="text-[9px] font-black uppercase tracking-[0.18em] opacity-70">
            {item.label}
          </span>
          <span className="text-xs font-black leading-none">{item.value}</span>
        </div>
      ))}
    </div>
  );
};

WorkflowContextBar.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      tone: PropTypes.oneOf([
        "default",
        "primary",
        "success",
        "warning",
        "danger",
        "neutral",
      ]),
    }),
  ),
  className: PropTypes.string,
};

export default WorkflowContextBar;
